import { createAxiosClient } from "@ntg/component-library/utilities";

export interface IRouteVersionD365 {
    dataAreaId: string;
    routeId: string;
    productionSiteId: string;
    itemNumber: string;
    productSizeId: string;
    productColorId: string;
    productConfigurationId: string;
    productStyleId: string;
    productVersionId: string;
}

export const getRouteVersionByItemD365 = async (
    itemNumber: string,
    dataAreaId: string,
): Promise<IRouteVersionD365 | null> => {
    const axiosAuth = createAxiosClient("D365FO");
    const response = await axiosAuth.get<IRouteVersionD365 | null>(
        `/RouteVersion/GetRouteVersionByItemD365`,
        { params: { itemNumber, dataAreaId } },
    );
    // 204 returns empty body — axios resolves to "" or null depending on parser
    return (response.status === 204 || !response.data) ? null : response.data;
};
